// src/__internal__/core/CoreProvider.tsx
import { createContext } from "react";
import { useDeferredValue, useSyncExternalStore } from "../shims/index.mjs";
import { jsx } from "react/jsx-runtime";
var CoreActionsContext = createContext(
  null
);
var CoreStateContext = createContext(null);
var CoreProvider = ({
  coreStore,
  children
}) => {
  const stack = useSyncExternalStore(
    coreStore.subscribe,
    coreStore.actions.getStack,
    coreStore.actions.getStack
  );
  const deferredStack = useDeferredValue(stack);
  return /* @__PURE__ */ jsx(CoreStateContext.Provider, { value: deferredStack, children: /* @__PURE__ */ jsx(CoreActionsContext.Provider, { value: coreStore.actions, children }) });
};
CoreProvider.displayName = "CoreProvider";
export {
  CoreActionsContext,
  CoreProvider,
  CoreStateContext
};
